// 全局 Vue 错误捕获插件
// 防止运行时错误导致整个页面崩溃显示 error.vue

import Vue from 'vue'

export default function () {
  if (process.client) {
    // 捕获 Vue 组件内的错误，阻止传播到 Nuxt 错误页
    Vue.config.errorHandler = function (err, vm, info) {
      console.error('[Vue Error]', info, err)
      // 错误只打印到控制台，不中断应用
    }

    // 捕获未处理的 Promise 拒绝
    window.addEventListener('unhandledrejection', function (event) {
      console.error('[Unhandled Promise]', event.reason)
      event.preventDefault() // 阻止默认的错误输出
    })

    // 捕获全局 JS 错误
    window.addEventListener('error', function (event) {
      console.error('[Global Error]', event.message, 'at', event.filename, ':', event.lineno)
      // 不阻止默认行为，但防止某些错误导致白屏
    })
  }
}
